(function () {
  // carousel-only (extracted from product_block.js slides.js)
  window.shopify = window.shopify || {};
  const uniqueClassRegex = new RegExp("^i[a-zA-Z0-9]{16}(-[a-zA-Z0-9]{16})*$");
  const isUniqueClass = (cls) => uniqueClassRegex.test(cls);
  const getPrimaryClass = (el) => {
    const classes = Array.from(el.classList || []);
    return classes.find((c) => isUniqueClass(c)) || classes[0] || "";
  };
  window.shopify.initializedSwiper = !!window.shopify?.initializedSwiper;
  window.shopify.initSwiper =
    window.shopify?.initSwiper ||
    (() => {
      if (!window.shopify.initializedSwiper) {
        window.shopify.initializedSwiper = true;
        if (window.shopify.initializedListeners && window.__shopifyInitSliders) {
          window.__shopifyInitSliders();
        }
      }
    });

  // Load carousel data from JSON or Shopify product data
  async function loadCarouselFromJSON() {
    try {
      let data;
      
      // Check if product data is available from Shopify
      if (window.productCarouselData && window.productCarouselData.images && window.productCarouselData.images.length > 0) {
        data = {
          images: window.productCarouselData.images,
          sliderConfig: {
            main: {
              breakpoints: {
                "0": {
                  speed: 300,
                  direction: "horizontal",
                  autoHeight: false,
                  slidesPerView: 1,
                  freeMode: false,
                  centeredSlides: true,
                  centerInsufficientSlides: true,
                  spaceBetween: 0
                }
              },
              navigation: {
                nextEl: ".shopify-slider-p0v3Wq2c0KULJHOO-button-next",
                prevEl: ".shopify-slider-p0v3Wq2c0KULJHOO-button-prev",
                disabledClass: "shopify-slider-button-disabled",
                hiddenClass: "shopify-slider-button-hidden",
                lockClass: "shopify-slider-button-lock",
                navigationDisabledClass: "shopify-slider-navigation-disabled"
              },
              watchOverflow: true,
              thumbs: {
                slideThumbActiveClass: "shopify-slider-thumb-active",
                thumbsContainerClass: "shopify-slider-thumbs"
              }
            },
            thumbnails: {
              breakpoints: {
                "0": {
                  speed: 300,
                  direction: "horizontal",
                  autoHeight: false,
                  slidesPerView: 4,
                  freeMode: false,
                  centeredSlides: false,
                  centerInsufficientSlides: false,
                  spaceBetween: 16
                },
                "769": {
                  speed: 300,
                  direction: "horizontal",
                  autoHeight: false,
                  slidesPerView: 6,
                  freeMode: false,
                  centeredSlides: false,
                  centerInsufficientSlides: false,
                  spaceBetween: 16
                }
              },
              navigation: {
                nextEl: ".shopify-slider-9MuTiHFVI9qvIaSA-button-next",
                prevEl: ".shopify-slider-9MuTiHFVI9qvIaSA-button-prev",
                disabledClass: "shopify-slider-button-disabled",
                hiddenClass: "shopify-slider-button-hidden",
                lockClass: "shopify-slider-button-lock",
                navigationDisabledClass: "shopify-slider-navigation-disabled"
              },
              watchOverflow: true,
              watchSlidesProgress: true
            }
          }
        };
      } else {
        // Fallback to JSON file
        const response = await fetch('data/carousel.json');
        if (!response.ok) {
          console.error('Failed to load carousel.json');
          return;
        }
        data = await response.json();
      }
      
      // Populate main slider
      const mainWrapper = document.getElementById('main-slider-wrapper');
      const thumbnailsWrapper = document.getElementById('thumbnails-slider-wrapper');
      
      if (mainWrapper && data.images && data.images.length > 0) {
        mainWrapper.innerHTML = '';
        data.images.forEach((image, index) => {
          const slide = document.createElement('div');
          slide.className = 'shopify-slider-slide iytPxehuLgUqoxXQ6';
          slide.setAttribute('data-shopify-type', 'slider-slide');
          slide.setAttribute('layerId', 'ytPxehuLgUqoxXQ6');
          
          const imageDiv = document.createElement('div');
          imageDiv.setAttribute('data-shopify-type', 'image');
          imageDiv.className = 'ivkJ7tiDLPBwLMk8t';
          
          const img = document.createElement('img');
          img.width = '100%';
          img.height = '100%';
          img.alt = image.alt || 'Product image';
          img.src = image.src;
          img.className = 'shopify-image shopify-image__main';
          img.decoding = 'async';
          
          // Build srcset
          if (image.srcset) {
            const srcsetParts = [];
            Object.keys(image.srcset).forEach(width => {
              srcsetParts.push(`${image.srcset[width]} ${width}w`);
            });
            img.srcset = srcsetParts.join(', ');
            img.sizes = '(max-width: 1280px) 100vw, 1280px';
          }
          
          // Set loading attributes
          if (index === 0) {
            img.loading = 'eager';
            img.fetchPriority = 'high';
          } else {
            img.loading = 'lazy';
            img.fetchPriority = 'auto';
          }
          
          if (image.width) img.setAttribute('width', image.width);
          if (image.height) img.setAttribute('height', image.height);
          
          imageDiv.appendChild(img);
          slide.appendChild(imageDiv);
          mainWrapper.appendChild(slide);
        });
      }
      
      // Populate thumbnails slider
      if (thumbnailsWrapper && data.images && data.images.length > 0) {
        thumbnailsWrapper.innerHTML = '';
        data.images.forEach((image, index) => {
          const slide = document.createElement('div');
          slide.className = 'shopify-slider-slide iA7jBRXnSUIAbCr1c';
          slide.setAttribute('data-shopify-type', 'slider-slide');
          slide.setAttribute('layerId', 'A7jBRXnSUIAbCr1c');
          
          const imageDiv = document.createElement('div');
          imageDiv.setAttribute('data-shopify-type', 'image');
          imageDiv.className = 'i9P5R4TQc9YakHTAG';
          
          const img = document.createElement('img');
          img.width = '100%';
          img.height = '100%';
          img.alt = image.alt || 'Product thumbnail';
          img.src = image.thumbnail || image.src;
          img.className = 'shopify-image shopify-image__main';
          img.decoding = 'async';
          
          // Build srcset for thumbnails
          if (image.srcset) {
            const srcsetParts = [];
            if (image.srcset['360']) srcsetParts.push(`${image.srcset['360']} 360w`);
            if (image.srcset['640']) srcsetParts.push(`${image.srcset['640']} 640w`);
            img.srcset = srcsetParts.join(', ');
            img.sizes = '(max-width: 640px) 100vw, 640px';
          }
          
          // Set loading attributes
          if (index === 0) {
            img.loading = 'eager';
            img.fetchPriority = 'high';
          } else {
            img.loading = 'lazy';
            img.fetchPriority = 'auto';
          }
          
          if (image.width) img.setAttribute('width', image.width);
          if (image.height) img.setAttribute('height', image.height);
          
          imageDiv.appendChild(img);
          slide.appendChild(imageDiv);
          thumbnailsWrapper.appendChild(slide);
        });
      }
      
      // Set up slider configuration
      const mainConfigNode = document.getElementById('shopify-slider-ip0v3Wq2c0KULJHOO-product-carousel-section-params');
      const thumbnailsConfigNode = document.getElementById('shopify-slider-i9MuTiHFVI9qvIaSA-product-carousel-section-params');
      
      if (mainConfigNode && data.sliderConfig && data.sliderConfig.main) {
        const mainConfig = {
          ...data.sliderConfig.main,
          a11y: false,
          containerModifierClass: "shopify-slider-",
          noSwipingClass: "shopify-slider-no-swiping",
          slideClass: "shopify-slider-slide",
          slideBlankClass: "shopify-slider-slide-blank",
          slideActiveClass: "shopify-slider-slide-active",
          slideVisibleClass: "shopify-slider-slide-visible",
          slideFullyVisibleClass: "shopify-slider-slide-fully-visible",
          slideNextClass: "shopify-slider-slide-next",
          slidePrevClass: "shopify-slider-slide-prev",
          wrapperClass: "shopify-slider-wrapper",
          lazyPreloaderClass: "shopify-slider-lazy-preloader",
          on: {}
        };
        mainConfigNode.textContent = JSON.stringify(mainConfig);
      }
      
      if (thumbnailsConfigNode && data.sliderConfig && data.sliderConfig.thumbnails) {
        const thumbnailsConfig = {
          ...data.sliderConfig.thumbnails,
          a11y: false,
          containerModifierClass: "shopify-slider-",
          noSwipingClass: "shopify-slider-no-swiping",
          slideClass: "shopify-slider-slide",
          slideBlankClass: "shopify-slider-slide-blank",
          slideActiveClass: "shopify-slider-slide-active",
          slideVisibleClass: "shopify-slider-slide-visible",
          slideFullyVisibleClass: "shopify-slider-slide-fully-visible",
          slideNextClass: "shopify-slider-slide-next",
          slidePrevClass: "shopify-slider-slide-prev",
          wrapperClass: "shopify-slider-wrapper",
          lazyPreloaderClass: "shopify-slider-lazy-preloader",
          on: {}
        };
        
        // Add breakpoint for 1024px+ to make thumbnails vertical
        if (!thumbnailsConfig.breakpoints) {
          thumbnailsConfig.breakpoints = {};
        }
        thumbnailsConfig.breakpoints['1024'] = {
          direction: 'vertical',
          slidesPerView: 'auto',
          spaceBetween: 10,
          freeMode: false,
          centeredSlides: false,
          centerInsufficientSlides: false
        };
        
        thumbnailsConfigNode.textContent = JSON.stringify(thumbnailsConfig);
      }
      
    } catch (error) {
      console.error('Error loading carousel data:', error);
    }
  }
  function initshopifySliders(root) {
    const scope = root || document;
    if (!window.shopify.initializedSwiper) {
      if (scope.querySelector('[data-shopify-type="slider"]')) {
        // const script = document.createElement("script");
        // script.onload = window.shopify.initSwiper;
        // script.src = window.shopify.swiperScriptUrl || "scripts/swiper-bundle.min.js";
        // document.body.appendChild(script);
        const tryLoad = (urls, idx = 0) => {
          if (!urls || idx >= urls.length) return;
          const script = document.createElement("script");
          script.onload = window.shopify.initSwiper;
          script.onerror = () => tryLoad(urls, idx + 1);
          script.src = urls[idx];
          document.body.appendChild(script);
        };
        const urls = [];
        if (window.shopify.swiperScriptUrl) urls.push(window.shopify.swiperScriptUrl);
        urls.push("https://eviqo.io/cdn/shop/t/14/assets/swiper-bundle.min.js");
        tryLoad(urls, 0);
      }
      return;
    }
    const thumbnailById = {};
    const mount = (container, kind = "slider") => {
      if (!container || !container.id) return;
      const paramsNode = document.getElementById(`shopify-slider-${container.id}-params`);
      const sectionId = container.closest(".__shopify")?.getAttribute("data-section-id");
      const sliderId = container.getAttribute("data-shopify-slider-id");
      try {
        if (!paramsNode || !paramsNode.innerHTML) return;
        const config = JSON.parse(paramsNode.innerHTML);
        if (sectionId && config.navigation) {
          config.navigation.nextEl = `[data-section-id='${sectionId}'] ${config.navigation.nextEl}`;
          config.navigation.prevEl = `[data-section-id='${sectionId}'] ${config.navigation.prevEl}`;
        }
        if (config.pagination) {
          const scopedSelector = `[data-section-id='${sectionId}'] ${config.pagination.el}`;
          config.pagination.el = scopedSelector;
          const pagEl = document.querySelector(scopedSelector);
          const bullet = pagEl?.querySelector(".shopify-slider-pagination-bullet");
          if (pagEl && bullet) {
            const bulletIdClass = getPrimaryClass(bullet);
            config.pagination.renderBullet = (index, className) =>
              `<span class="${className} ${bulletIdClass}"></span>`;
          }
        }
        config.on = config.on || {};
        config.on.changeDirection = (swiper) => {
          if (swiper.params.direction === "horizontal") {
            const wrapper = container.querySelector(":scope > .shopify-slider-wrapper");
            if (wrapper) wrapper.style.height = "";
          }
        };
        if (kind === "thumbnails") {
          const wrapper = container.querySelector(":scope > .shopify-slider-wrapper");
          const parentContainer = container.closest('.ilZAXLa0KEQPTS9q2');
          const mainImageContainer = document.querySelector('.ip0v3Wq2c0KULJHOO');
          let lastMainImageHeight = 0;
          let isUpdating = false;
          
          // Set thumbnail width based on screen size and sync height with main image for screens 1024px and above
          function setThumbnailWidth() {
            if (isUpdating) return; // Prevent recursive calls
            const isDesktop = window.innerWidth >= 1024;
            if (isDesktop) {
              const thumbnailSlides = container.querySelectorAll('.shopify-slider-slide');
              
              // Determine thumbnail width based on screen size
              let thumbnailWidth = 75; // Default for 1024px
              const screenWidth = window.innerWidth;
              if (screenWidth >= 1920) {
                thumbnailWidth = 120; // 1920px and above
              } else if (screenWidth >= 1440) {
                thumbnailWidth = 100; // 1440px to 1919px
              } else {
                thumbnailWidth = 75; // 1024px to 1439px
              }
              
              // Get main image height
              let mainImageHeight = 0;
              if (mainImageContainer) {
                mainImageHeight = mainImageContainer.offsetHeight || mainImageContainer.clientHeight || 0;
              }
              
              // Only update if height changed significantly (more than 5px difference)
              if (Math.abs(mainImageHeight - lastMainImageHeight) < 5 && lastMainImageHeight > 0) {
                mainImageHeight = lastMainImageHeight;
              }
              
              // Set thumbnail width
              thumbnailSlides.forEach(slide => {
                slide.style.width = `${thumbnailWidth}px`;
                slide.style.minWidth = `${thumbnailWidth}px`;
                slide.style.flexShrink = '0';
                slide.style.flexBasis = `${thumbnailWidth}px`;
              });
              
              // If main image height is available, sync thumbnail container height
              if (mainImageHeight > 0) {
                isUpdating = true;
                
                // Set thumbnail container height to match main image
                if (container) {
                  container.style.height = `${mainImageHeight}px`;
                  container.style.minHeight = `${mainImageHeight}px`;
                  container.style.maxHeight = `${mainImageHeight}px`;
                }
                
                if (parentContainer) {
                  parentContainer.style.height = `${mainImageHeight}px`;
                  parentContainer.style.minHeight = `${mainImageHeight}px`;
                  parentContainer.style.maxHeight = `${mainImageHeight}px`;
                }
                
                // Set thumbnail height to match width (square thumbnails)
                thumbnailSlides.forEach(slide => {
                  slide.style.height = `${thumbnailWidth}px`;
                  slide.style.minHeight = `${thumbnailWidth}px`;
                });
                
                lastMainImageHeight = mainImageHeight;
                isUpdating = false;
              }
              
              // Fix wrapper to not clip images
              if (wrapper) {
                wrapper.style.height = mainImageHeight > 0 ? `${mainImageHeight}px` : 'auto';
                wrapper.style.minHeight = '0';
                wrapper.style.maxHeight = mainImageHeight > 0 ? `${mainImageHeight}px` : 'none';
                wrapper.style.overflow = 'visible';
                wrapper.style.width = `${thumbnailWidth}px`;
              }
              
              // Fix parent container to not clip
              if (parentContainer) {
                parentContainer.style.overflow = 'visible';
              }
              
              // Fix slider container itself
              container.style.overflow = 'visible';
            } else {
              // Reset to auto width for mobile
              const thumbnailSlides = container.querySelectorAll('.shopify-slider-slide');
              thumbnailSlides.forEach(slide => {
                slide.style.width = '';
                slide.style.minWidth = '';
                slide.style.flexShrink = '';
                slide.style.flexBasis = '';
              });
              
              // Reset wrapper for mobile
              if (wrapper) {
                wrapper.style.height = '';
                wrapper.style.minHeight = '';
                wrapper.style.maxHeight = '';
                wrapper.style.overflow = '';
                wrapper.style.width = '';
              }
              
              // Reset parent container for mobile
              if (parentContainer) {
                parentContainer.style.overflow = '';
                parentContainer.style.height = '';
                parentContainer.style.minHeight = '';
                parentContainer.style.maxHeight = '';
              }
              
              container.style.overflow = '';
              container.style.height = '';
              container.style.minHeight = '';
              container.style.maxHeight = '';
              
              // Reset thumbnail slide heights
              const resetSlides = container.querySelectorAll('.shopify-slider-slide');
              resetSlides.forEach(slide => {
                slide.style.height = '';
                slide.style.minHeight = '';
              });
              
              lastMainImageHeight = 0;
            }
          }
          
          // Function to sync thumbnail height with main image (with debounce)
          let syncTimeout = null;
          function syncThumbnailHeight() {
            if (syncTimeout) {
              clearTimeout(syncTimeout);
            }
            syncTimeout = setTimeout(() => {
              if (window.innerWidth >= 1024 && mainImageContainer && !isUpdating) {
                const mainImageHeight = mainImageContainer.offsetHeight || mainImageContainer.clientHeight || 0;
                if (mainImageHeight > 0 && Math.abs(mainImageHeight - lastMainImageHeight) >= 5) {
                  setThumbnailWidth();
                  if (thumbsSwiper && !isUpdating) {
                    requestAnimationFrame(() => {
                      if (thumbsSwiper) {
                        thumbsSwiper.update();
                      }
                    });
                  }
                }
              }
            }, 150);
          }
          
          // Set width before initialization
          setThumbnailWidth();
          
          const thumbsSwiper = new Swiper(container, config);
          thumbnailById[`${sliderId}`] = thumbsSwiper;
          
          // Set width after initialization and on resize
          if (thumbsSwiper) {
            thumbsSwiper.on('init', () => {
              setTimeout(syncThumbnailHeight, 200);
            });
            
            thumbsSwiper.on('resize', () => {
              syncThumbnailHeight();
            });
            
            // Don't call on update to avoid loops
          }
          
          // Observe main image container for height changes (only once)
          if (mainImageContainer && window.ResizeObserver) {
            let observerTimeout = null;
            const resizeObserver = new ResizeObserver(() => {
              if (observerTimeout) {
                clearTimeout(observerTimeout);
              }
              observerTimeout = setTimeout(() => {
                syncThumbnailHeight();
              }, 200);
            });
            resizeObserver.observe(mainImageContainer);
          }
          
          // Initial sync after images load
          setTimeout(syncThumbnailHeight, 300);
          setTimeout(syncThumbnailHeight, 800);
          
          // Handle window resize
          let resizeTimeout;
          const handleResize = () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
              setThumbnailWidth();
              syncThumbnailHeight();
            }, 200);
          };
          window.addEventListener('resize', handleResize);
        } else {
          if (config.thumbs && thumbnailById?.[`${sliderId}`]) {
            config.thumbs = { swiper: thumbnailById[`${sliderId}`], ...config.thumbs };
          }
          new Swiper(container, config);
        }
      } catch (err) {}
    };
    scope.querySelectorAll('[data-shopify-type="thumbnails"]').forEach((el) => mount(el, "thumbnails"));
    scope.querySelectorAll('[data-shopify-type="slider"]').forEach((el) => mount(el));
  }
  window.__shopifyInitSliders = function (root) {
    initshopifySliders(root || document);
  };
  function readySlides() {
    // Load carousel data from JSON first, then initialize sliders
    loadCarouselFromJSON().then(() => {
      window.shopify.initializedListeners = true;
      if (window.__shopifyInitSliders) {
        window.__shopifyInitSliders();
      }
    });
  }
  if (document.readyState !== "loading") readySlides();
  else document.addEventListener("DOMContentLoaded", readySlides);
})();

